export enum ChildInsuranceType {
  NEWCHILD_BASIC = "newchildBasic",
  NEWCHILD_EXTRA = "newchildExtra",
  NEWCHILD_TOTAL = "newchildTotal",
}
